import {
    Box,
    Stack,
    Button,
    useTheme
} from "@mui/material";
import React, {useState} from 'react';
import useResponsive from "../../hooks/useResponsive";
import { tokens } from "../../theme";
import appealsStore from '../../store/appealsStore';
import {observer} from "mobx-react-lite";

import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Header from "../../components/Header";
import Appeals from "../../sections/Appeals/Appeals";
import Appeal from "../../sections/Appeal/Appeal";
import GlobalLiveSearch from "../../sections/GlobalLiveSearch/GlobalLiveSearch";
import QueueStatus from "../../components/QueueStatus";
import AsteriskService from "../../services/AsteriskService";

const AppAppeals = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isDesktop = useResponsive("up", "md");
    const isMobile = useResponsive("between", "md", "xs", "sm");

    const [openSearch, setOpenSearch] = useState(false)

    const [loading, setLoading] = useState(false);
    const [openQueueStatus, setOpenQueueStatus] = useState(false);
    const [queueStatus, setQueueStatus] = useState([]);

    const handleOpenQueue = () => {
        setOpenQueueStatus(true);
        setLoading(false)         
        const fetcher = async () => {
            try {
                const responseAsteriskQueueStatus = await AsteriskService.getQueueStatus()
                setQueueStatus(responseAsteriskQueueStatus.data.queue_status)
                setOpenQueueStatus(true);
                setLoading(true)
            } catch (e) {
                console.log(e);
            }
        };
        fetcher()
    }

    const handleUpdateQueue = () => {
        setLoading(false)         
        const fetcher = async () => {
            const errors = []
            try {
                const responseAsteriskQueueStatus = await AsteriskService.getQueueStatus()
                setQueueStatus(responseAsteriskQueueStatus.data.queue_status)
            } catch (e) {
                console.log(e);
                errors.push("An error occurred while updating the queue status.")
            }
            setLoading(true)
            return errors
        };
        return fetcher()
    }

    const handlePutQueue = () => {
        setLoading(false)         
        const fetcher = async () => {
            const errors = []
            try {
                await AsteriskService.putQueueStatus(queueStatus)
            } catch (e) {
                console.log(e);
                errors.push("An error occurred while adding the agent to the queue")
            }
            try {
                const responseAsteriskQueueStatus = await AsteriskService.getQueueStatus()
                setQueueStatus(responseAsteriskQueueStatus.data.queue_status)
            } catch (e) {
                console.log(e);
                errors.push("An error occurred while updating the queue status.")
            }
            setLoading(true)
            return errors
        };
        return fetcher()
    }

    const handleClose = () => {
        setLoading(false)
        setOpenQueueStatus(false);
    }

    const handleOpenSearch = () => {
        setOpenSearch(true)
    }

    const handleCloseSearch = () => {
        setOpenSearch(false)
    }

    return (
        <Box 
            ml= {isMobile ? "0px" : "20px"}
            mr= {isMobile ? "0px" : "20px"}
        >
            {/* MODAL QueueStatus */}
                <QueueStatus
                    open={openQueueStatus}
                    handleClose={handleClose}
                    loading={loading}
                    handlePutQueue={handlePutQueue}
                    handleUpdateQueue={handleUpdateQueue}
                    queueStatus={queueStatus}
                    setQueueStatus={setQueueStatus}
                >
                </QueueStatus>
            {/* HEADER */}
            {!isMobile && 
                <Box display="flex" justifyContent="space-between" alignItems="center" height={'100px'}>
                    <Header title="Appeals" subtitle="Appeals" />

                    <Box>
                        <Button
                            onClick={() => {handleOpenQueue({})}}
                            sx={{
                                backgroundColor: colors.greenAccent[700],
                                color: colors.grey[100],
                                fontSize: "14px",
                                fontWeight: "bold",
                                padding: "10px 20px",
                            }}
                        >
                        <HeadsetMicIcon sx={{ mr: "10px" }} />
                            Queue status
                        </Button>
                    </Box>
                </Box>
            }
            {/* CONTEXT */}
            <Stack 
                direction="row"
                alignItems="stretch"
                spacing={1.5}
                sx={{ 
                    height: isMobile ? "calc(100vh - 58px)" : "calc(100vh - 58px - 100px)", 
                    // height: "100%", 
                    minWidth: "320px" 
                }} 
            >

                {isDesktop && (
                    <>
                    <Appeals handleOpenQueue={handleOpenQueue} />
                    {appealsStore.appeal.id && <Appeal />}
                    <GlobalLiveSearch
                        content={
                            {
                                object_type: appealsStore.appeal.source_type,
                                object: appealsStore.appeal.source,
                            }
                        }
                        sx={{
                            height: isMobile ? "calc(100vh - 58px)" : "calc(100vh - 58px - 100px)",
                            width: "100%",
                            minWidth: "320px",
                            overflowY: "scroll",
                            backgroundColor:
                                theme.palette.mode === "light"
                                    ? "#F8FAFF"
                                    : theme.palette.background,
                            boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                        }}
                    />
                    </>
                )}

                {!isDesktop && (
                    <>
                    {openSearch ?
                    <Box
                        sx={{
                            height: isMobile ? "calc(100vh - 58px)" : "calc(100vh - 58px - 100px)",
                        }}
                    >
                        <GlobalLiveSearch
                            handleBack={handleCloseSearch}
                            content={
                                {
                                    object_type: appealsStore.appeal.source_type,
                                    object: appealsStore.appeal.source,
                                }
                            }
                            sx={{
                                height: isMobile ? "calc(100vh - 58px)" : "calc(100vh - 58px - 100px)",
                                width: "100%",
                                minWidth: "320px",
                                overflowY: "scroll",
                                backgroundColor:
                                    theme.palette.mode === "light"
                                        ? "#F8FAFF"
                                        : theme.palette.background,
                                boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                            }}
                        />
                    </Box>
                    : appealsStore.appeal.id ? <Appeal handleOpenSearch={handleOpenSearch}/> : <Appeals  handleOpenSearch={handleOpenSearch} handleOpenQueue={handleOpenQueue} />
                    }   
                    </>
                )}
                
            </Stack>
        </Box>
    )
};

export default observer(AppAppeals);